import { mapGetters, mapState } from 'vuex'

export const computed = {
  ...mapGetters('user', ['currentHoaId', 'currentUnitId', 'currentOwnerId']),
  ...mapState({
    hoaId: state => state.user.selectedHoaId
  })
}
